import { IUserInformation } from '../../interfaces/userInformation';
import * as UserProfileActions from '../actions/user-profile.actions';

const initialState: IUserInformation = {
  userId: 0,
  emailAddress: null,
  firstName: '',
  lastName: '',
  lastSelectedOrganizationId: 0,
  lastSelectedOrganizationName: '',
  lastSelectedTankProfileId: null,
  organizationid: 0,
  organizationName: '',
  parentOrganizationTree: [],
  userName: '',
  legacyAppLoginURL: '',
  features: [],
  roles: [],
  permissions: [],
  cultureCode: '',
  lastSelectedTankQuickFilter: null,
  userTimeZoneName: '',
  mustChangePassword : false,
  automaticRedirect : false,
  isImpersonating: false,
  impersonatingUserId: 0,
  originatingUserId: 0,
  originatingUserName: '',
  userPreferences: {
    timeZoneId: 0,
    languageId: 0,
    unitOfMeasureId: 0,
    daylightSavings: false,
    homepage: 'dashboard',
  },
};

export function userProfileReducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IUserInformation = initialState,
  action: UserProfileActions.Actions
): IUserInformation {
  switch (action.type) {
    case UserProfileActions.SET_LAST_SELECTED_TANK_PROFILE:
      if (!action.tankProfile) {
        return state;
      }
      return {
        ...state,
        lastSelectedTankProfileId: action.tankProfile.tankProfileId,
      };
    case UserProfileActions.SET_LAST_SELECTED_ORGANIZATION:
      if (!action.org) {
        return state;
      }
      return {
        ...state,
        lastSelectedOrganizationId: action.org.orgId,
        lastSelectedOrganizationName: action.org.orgName,
      };
    case UserProfileActions.SET_LAST_SELECTED_TVP:
      if (!action.tvp) {
        return state;
      }
      return {
        ...state,
        lastSelectedOrganizationId: action.tvp.organizationId,
        lastSelectedOrganizationName: action.tvp.organizationName,
      };
    case UserProfileActions.SET_USER_INFO:
      if (action.userInformation) {
        return action.userInformation;
      }
      return state;
    case UserProfileActions.GET_PARENT_ORGANIZATION_TREE:
      if (!action.parentOrgTree) {
        return state;
      }
      return {
        ...state,
        parentOrganizationTree: action.parentOrgTree,
      };
    case UserProfileActions.SET_LAST_SELECTED_TANK_QUICK_FILTER:
      return {
        ...state,
        lastSelectedTankQuickFilter: action.tankQuickFilter,
      };
    default:
      return state;
  }
}
